import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { BancoService } from '../../../services/BancoService';
import { Validators } from '../../../components/CatalogForm/validators';

const bancoFields = [
  {
    name: 'banco',
    label: 'Banco',
    type: 'text',
    col: 2,
    placeholder: 'Ej. 10',
    validators: [Validators.required('La clave del banco es obligatoria')],
  },
  {
    name: 'banco_nombre',
    label: 'Nombre',
    type: 'text',
    col: 5,
    placeholder: 'Ej. BANCOMER',
    validators: [Validators.required('El nombre es obligatorio')],
  },
  {
    name: 'banco_cvesat',
    label: 'Clave Sat',
    type: 'text',
    col: 5,
    placeholder: 'Ej. 012',
    validators: [Validators.required('La clave SAT es obligatoria')],
  },
  {
    name: 'banco_ncorto',
    label: 'Nombre Corto',
    type: 'text',
    col: 6,
    placeholder: 'Ej. BBVA',
    validators: [Validators.required('El nombre corto es obligatorio')],
  },
  {
    name: 'banco_rsocial',
    label: 'Razón Social',
    type: 'text',
    col: 6,
    placeholder: 'Ej. BBVA Bancomer S.A.',
    validators: [Validators.required('La razón social es obligatoria')],
  },
  {
    name: 'banco_rfc',
    label: 'RFC',
    type: 'text',
    col: 12,
    placeholder: 'Ej. BBA830831LJ2',
    validators: [
      Validators.required('El RFC es obligatorio'),
      Validators.rfc('El RFC no tiene un formato válido (12 o 13 caracteres)'),
    ],
  },
];

export const BancoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (bancoId) => {
    return await BancoService.obtenerPorId(bancoId);
  };

  const handleSubmit = async (values) => {
    return await BancoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Banco"
      subtitle="Complete la información del catálogo de banco"
      fields={bancoFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Bancos"
    />
  );
};

export default BancoForm;
